import React from 'react';

const ToggleSwitch = ({ isOn, onToggle, disabled = false }) => {
  return (
    <button
      onClick={onToggle}
      disabled={disabled}
      className={`toggle-switch ${isOn ? 'active' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <div className="toggle-thumb"></div>
    </button>
  );
};

export default ToggleSwitch;